import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import { ebooks } from "./ebooksData";
import EbookModal from "./ebookpopup/EbookModal";

const EbookDetails = () => {
  const { slug } = useParams();
  const ebook = ebooks.find((item) => item.slug === slug);
  const [showEbookModal, setShowEbookModal] = useState(false);

  if (!ebook) {
    return (
      <Container className="py-5 text-center">
        <h2>Ebook not found</h2>
        <p>The selected ebook could not be found.</p>
        <Link to="/ebooks" className="btn btn-dark">
          Back to Ebooks
        </Link>
      </Container>
    );
  }

  return (
    <>
      <style>{`
        .ebook-detail { font-family: 'Outfit', sans-serif; background: #fff; color: #0f172a; }
        .hero { padding: 80px 0 80px; text-align: center; background: #effdff; }
        .hero h1 { color:#0f172a; font-size: 2.6rem; font-weight: 800; }
        .hero p { color: #475569; font-size: 1.2rem; max-width: 900px; margin: 0 auto; }
        .content { padding: 40px 0; }
        .ebook-image { width: 100%; border-radius: 12px; object-fit: cover; max-height: 500px; }
        .ebook-details p { margin-bottom: 16px; }
        .actions { margin-top: 26px; display: flex; gap: 12px; flex-wrap: wrap; }
        .actions button, .actions a { padding: 10px 16px; font-weight: 700; border-radius: 10px; border: 0; color: #fff; text-decoration: none; cursor: pointer; }
        .actions .download { background: #ee0000; }
        .actions .back { color: #e00;
  background: #fff;
  border: 1px solid #e00; }
      `}</style>

      <div className="ebook-detail">
        <section className="hero">
          <Container>
            <h1>{ebook.title}</h1>
            <p>{ebook.excerpt}</p>
          </Container>
        </section>

        <Container className="content">
          <img src={ebook.image} alt={ebook.title} className="ebook-image" />
          <div className="ebook-details mt-4">
            {ebook.details.map((detail, idx) => (
              <p key={idx}>{detail}</p>
            ))}
          </div>

          <div className="actions">
            <button
              className="download"
              onClick={() => setShowEbookModal(true)}
            >
              Download Ebook
            </button>
            <Link to="/ebooks" className="back">
              <ArrowRight size={14} /> Back to Ebooks
            </Link>
          </div>
        </Container>

        <EbookModal
          show={showEbookModal}
          onHide={() => setShowEbookModal(false)}
          ebookTitle={ebook.title}
          ebookPdfFile={ebook.pdfFile}
        />
      </div>
    </>
  );
};

export default EbookDetails;
